module.exports = __webpack_public_path__ + "media/christmas.6560f455.mp4";